/* ARBACH Warenkorb — Mengen und Entfernen ohne Neuladen (Auftrag 20, A6, Befund N14).

   Ohne dieses Skript bleibt alles wie bisher: Plus, Minus und × sind Submit-
   Knöpfe des EINEN Warenkorb-Formulars (name="updates[<key>]"), die Seite lädt
   neu und man steht wieder oben.

   Mit Skript:
     1. Klick abfangen, Knopf sperren, Doppeltippen ignorieren (busy).
     2. Notiz geändert? Erst sichern (/cart/update.js) — der alte Formular-Weg
        nahm sie automatisch mit, das darf hier nicht verloren gehen.
     3. /cart/change.js mit Section Rendering: Shopify liefert im selben Aufruf
        das neu gerenderte HTML der Warenkorb-Sektion und des Shop-Kopfs.
     4. Sektion an Ort und Stelle ersetzen (Positionen, Rabattzeilen, Summe,
        Hinweise, Kasse-Leiste), Zähler im Kopf ersetzen, Scrollposition
        halten, Fokus auf den gleichen Knopf der Zeile, neue Summe per
        aria-live ansagen.
   Fehler (auch 429 „zu viele Anfragen"): kurze Meldung, dann Rückfall auf das
   heutige Formular — der Knopf wird normal abgeschickt.

   Die Kasse-Leiste (Befund W1) wird hier gesteuert statt im Inline-Skript der
   Sektion: Inline-Skripte laufen nach dem Ersetzen nicht erneut. */
(function () {
  'use strict';

  var busy = false;

  function wurzel() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function bereich() { return document.querySelector('[data-warenkorb]'); }

  // ---------------------------------------------------------- Kasse-Leiste
  var kasseIO = null;
  var schmal = window.matchMedia ? window.matchMedia('(max-width: 1023.98px)') : null;
  function kasseLeiste() {
    if (kasseIO) { kasseIO.disconnect(); kasseIO = null; }
    var leiste = document.querySelector('[data-arbach-kasse-leiste]');
    var knopf = document.querySelector('.arbach-cart__summary .arbach-cart__checkout');
    if (!leiste || !knopf || !('IntersectionObserver' in window)) return;
    var imBild = true;
    function setze() { leiste.classList.toggle('is-sichtbar', !!(schmal && schmal.matches) && !imBild); }
    kasseIO = new IntersectionObserver(function (e) { imBild = e[e.length - 1].isIntersecting; setze(); });
    kasseIO.observe(knopf);
    setze();
  }
  if (schmal && schmal.addEventListener) schmal.addEventListener('change', kasseLeiste);

  // ------------------------------------------------------------- Meldungen
  function ansage(text) {
    var el = document.getElementById('arbach-cart-live');
    if (!el) {
      el = document.createElement('p');
      el.id = 'arbach-cart-live';
      el.className = 'arbach-sr-only';
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = '';
    window.setTimeout(function () { el.textContent = text; }, 60);
  }
  function meldung(r, text) {
    var alt = r.querySelector('.arbach-cart__meldung');
    if (alt) alt.parentNode.removeChild(alt);
    var p = document.createElement('p');
    p.className = 'arbach-cart__meldung';
    p.setAttribute('role', 'alert');
    p.textContent = text;
    var ziel = r.querySelector('.arbach-cart__lines') || r.firstElementChild;
    if (ziel) ziel.insertBefore(p, ziel.firstChild);
  }

  // --------------------------------------------------------------- Anfrage
  function post(pfad, daten) {
    return fetch(wurzel() + pfad, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(daten),
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) { var f = new Error('HTTP ' + res.status); f.status = res.status; throw f; }
      return res.json();
    });
  }

  // Heutiges Verhalten: Formular mit genau diesem Knopf absenden
  function absenden(form, knopf) {
    if (!form) return;
    // Ein gesperrter Knopf schickt seinen Wert nicht mit — vorher freigeben
    // (im Test am 05.10. ging die Mengenänderung sonst verloren).
    knopf.disabled = false;
    if (typeof form.requestSubmit === 'function') { form.requestSubmit(knopf); return; }
    var h = document.createElement('input');
    h.type = 'hidden'; h.name = knopf.name; h.value = knopf.value;
    form.appendChild(h);
    form.submit();
  }

  // --------------------------------------------------------- Kopf-Zähler
  function kopf(html) {
    if (!html) return;
    var neu = new DOMParser().parseFromString(html, 'text/html');
    var alt = document.querySelectorAll('[data-kopf-warenkorb]');
    var frisch = neu.querySelectorAll('[data-kopf-warenkorb]');
    for (var i = 0; i < alt.length && i < frisch.length; i++) alt[i].innerHTML = frisch[i].innerHTML;
  }

  // ------------------------------------------------------------- Ändern
  function aendern(knopf) {
    var r = bereich();
    var form = knopf.form;
    if (!r || !form) return;
    var sektion = r.getAttribute('data-warenkorb');
    var key = knopf.name.slice(8, -1);                       // updates[KEY]
    var menge = parseInt(knopf.value, 10);
    var zeile = knopf.closest('[data-key]');
    var stepper = Array.prototype.slice.call(zeile ? zeile.querySelectorAll('.arbach-cart__step') : []);
    var rolle = knopf.classList.contains('arbach-cart__remove') ? 'weg' : String(stepper.indexOf(knopf));
    var y = window.scrollY;

    busy = true;
    knopf.disabled = true;
    r.setAttribute('aria-busy', 'true');
    r.classList.add('is-laedt');

    var notiz = form.querySelector('textarea[name="note"]');
    var vorab = (notiz && notiz.value !== notiz.defaultValue)
      ? post('cart/update.js', { note: notiz.value })
      : Promise.resolve(null);

    vorab.then(function () {
      return post('cart/change.js', { id: key, quantity: menge, sections: [sektion, 'shop-header'], sections_url: window.location.pathname });
    }).then(function (daten) {
      var html = daten && daten.sections && daten.sections[sektion];
      if (!html) throw new Error('keine Sektion');
      var neu = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-warenkorb]');
      if (!neu) throw new Error('kein Warenkorb im HTML');
      r.innerHTML = neu.innerHTML;
      kopf(daten.sections['shop-header']);
      kasseLeiste();
      if (typeof window.arbFabNeu === 'function') window.arbFabNeu();
      // Position halten (Browser-Scrollverankerung kann um Zeilenhöhen springen)
      if (Math.abs(window.scrollY - y) > 1) window.scrollTo(0, Math.min(y, document.documentElement.scrollHeight - window.innerHeight));
      // Fokus: gleicher Knopf derselben Zeile, sonst Nachbar, sonst Überschrift
      var ziel = null;
      var neueZeile = key && r.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
      if (neueZeile && rolle !== 'weg') {
        var k = neueZeile.querySelectorAll('.arbach-cart__step');
        ziel = (k[+rolle] && !k[+rolle].disabled) ? k[+rolle] : (k[1 - +rolle] || null);
      }
      if (!ziel) {
        ziel = r.querySelector('.arbach-cart__name') || r.querySelector('.arbach-cart__title');
        if (ziel && ziel.tagName !== 'A' && !ziel.hasAttribute('tabindex')) ziel.setAttribute('tabindex', '-1');
      }
      if (ziel) { try { ziel.focus({ preventScroll: true }); } catch (e) { ziel.focus(); } }
      var summe = r.querySelector('[data-cart-summe]');
      var vorlage = r.getAttribute('data-live') || '';
      ansage(summe ? vorlage.replace('[summe]', summe.textContent.trim()) : vorlage.replace('[summe]', ''));
      // Duftproben (Auftrag 34): Preisstufe nach der Mengenänderung abgleichen,
      // bei einer Änderung neu laden (assets/arbach-proben.js)
      if (window.arbachProben) {
        window.arbachProben.abgleichen().then(function (g) { if (g) window.arbachProben.neuLaden(); }).catch(function () {});
      }
    }).catch(function () {
      meldung(r, r.getAttribute('data-fehler') || '');
      window.setTimeout(function () { absenden(form, knopf); }, 1400);
      return 'fehler';
    }).then(function (ergebnis) {
      if (ergebnis === 'fehler') return;   // Seite lädt gleich neu, gesperrt lassen
      busy = false;
      var b = bereich();
      if (b) { b.removeAttribute('aria-busy'); b.classList.remove('is-laedt'); }
    });
  }

  document.addEventListener('click', function (e) {
    var knopf = e.target && e.target.closest && e.target.closest('[data-warenkorb] button[name^="updates["]');
    if (!knopf || knopf.disabled) return;
    if (!window.fetch || !window.DOMParser || !window.Promise) return;   // Formular wie bisher
    e.preventDefault();
    if (busy) return;                                                    // Doppeltippen
    aendern(knopf);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kasseLeiste);
  else kasseLeiste();
})();
